/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useCallback } from 'react';
import { buildComponentArray } from 'modules/shared/utils';
import { Field, FieldProps } from 'formik';
import { useTranslation } from 'react-i18next';
import { HourSelectControlProps } from './hour-select-control-type';

import styles from './hour-select-control-component.module.css';

interface Slot {
    id: number;
    text: string;
}

export const HourSelectControl: React.FC<HourSelectControlProps> = ({
    name,
    slots,
    required,
    ...rest
}: HourSelectControlProps) => {
    const [itemClicked, setItemClicked] = useState(-1);

    const slotsWithId: Slot[] = slots.map((text, index) => {
        return {
            id: index,
            text,
        };
    });
    // const onlyHours: number[] = slots.map(opt => parseInt(opt.split(':')[0], 10));

    // const morningList = slotsWithId.filter((_, index) => onlyHours[index] < 12);
    // const afternoonList = slotsWithId.filter((_, index) => onlyHours[index] >= 12 && onlyHours[index] < 17);
    // const eveningList = slotsWithId.filter((_, index) => onlyHours[index] >= 17);

    const { t } = useTranslation();
    const validate = useCallback(
        (value: string): string | undefined => {
            let result;
            if (!value && required) {
                result = t('shared.form.required');
            }

            return result;
        },
        [required, t],
    );

    return (
        <Field name={name} required={required} validate={validate} {...rest}>
            {({ form }: FieldProps) => {
                const hourItemRenderer = ({ id, text }: Slot): JSX.Element => {
                    return (
                        <div
                            key={id}
                            className={`${styles.hour} ${id === itemClicked ? styles.clicked : ''}`}
                            onClick={() => {
                                setItemClicked(id);
                                form.setFieldValue(name, text);
                            }}
                        >
                            {text}
                        </div>
                    );
                };

                return slots.length !== 0 ? (
                    <div className={styles.rootContainer}>
                        <div className={styles.hoursContainer}>
                            {buildComponentArray(slotsWithId, hourItemRenderer)}
                        </div>
                    </div>
                ) : (
                    <div className={styles.hoursContainer}>Aucun créneaux disponibles à cette date.</div>
                );
            }}
        </Field>
    );
};
